import { Matrix4 } from 'three'

import { Matrix4FloatType, TripleFloatType } from './types'

const positionFactor = 2

export function translateCameraPositionalData({
    newViewerCameraPosition,
    newViewerPartMatrixArray,
}: {
    newViewerCameraPosition: TripleFloatType
    newViewerPartMatrixArray: Matrix4FloatType
}) {
    const [x, y, z] = newViewerCameraPosition
    const newCameraMatrix = new Matrix4()
    const newPartMatrix = new Matrix4()
    const prodCameraMatrix = new Matrix4()

    newCameraMatrix.fromArray([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, x, y, z, 1])
    newPartMatrix.fromArray(newViewerPartMatrixArray)
    prodCameraMatrix.copy(newCameraMatrix.invert())
    prodCameraMatrix.multiply(newPartMatrix)

    const finalProdCameraMatrix = new Matrix4().copy(prodCameraMatrix)

    finalProdCameraMatrix.invert()

    const prodCameraMatrixArray = finalProdCameraMatrix.elements

    const prodCameraPositionArray = [
        prodCameraMatrixArray[12] * positionFactor,
        prodCameraMatrixArray[13] * positionFactor,
        prodCameraMatrixArray[14] * positionFactor,
    ]

    const prodCameraTargetArray = [0, 0, 0]

    const prodCameraUp = [
        prodCameraMatrixArray[4],
        prodCameraMatrixArray[5],
        prodCameraMatrixArray[6],
    ]

    return {
        position: prodCameraPositionArray,
        target: prodCameraTargetArray,
        up: prodCameraUp,
    }
}
